import { LicitacionListResponse, LicitacionFilters, Licitacion } from "@/types/licitacion";
import { fetchWithAuth } from "./client";

// Mejora H (changelog cliente): clonar una licitación como plantilla.
export interface CloneLicitacionParams {
  titulo?: string;
  referencia?: string;
  include_proposals?: boolean;
  include_etiquetas?: boolean;
  include_notas?: boolean;
}

export const licitacionesApi = {
  getList: async (filters: LicitacionFilters = {}): Promise<LicitacionListResponse> => {
    const params = new URLSearchParams();

    if (filters.page) params.set("page", String(filters.page));
    if (filters.page_size) params.set("page_size", String(filters.page_size));
    if (filters.estado) params.set("estado", filters.estado);
    if (filters.tipo_contrato) params.set("tipo_contrato", filters.tipo_contrato);
    if (filters.search) params.set("search", filters.search);
    if (filters.sort_by) params.set("sort_by", filters.sort_by);
    if (filters.sort_order) params.set("sort_order", filters.sort_order);

    const query = params.toString();
    return fetchWithAuth(`/api/v1/licitaciones${query ? `?${query}` : ""}`);
  },

  clone: async (
    licitacionId: string,
    params: CloneLicitacionParams = {}
  ): Promise<Licitacion> => {
    return fetchWithAuth(`/api/v1/licitaciones/${licitacionId}/clone`, {
      method: "POST",
      body: JSON.stringify(params),
    });
  },

  // Solo admins (el backend devuelve 403 si no). La UI oculta el botón
  // a no-admins; este endpoint sirve también por API.
  remove: async (licitacionId: string): Promise<void> => {
    await fetchWithAuth(`/api/v1/licitaciones/${licitacionId}`, {
      method: "DELETE",
    });
  },
};
